<div class="burger__line"></div>
<div class="burger__line"></div>
<div class="burger__line"></div>
@if (count()) {
  <div class="burger__count">{{ count() }}</div>
}
